import { wsService } from "./wsService";

const section = "notifications";

// Devuelve { list, unread } del usuario logueado
function filter() {
  return wsService.make_post_request(section + "/list", {});
}

function read(id) {
  return wsService.make_post_request(section + "/read", { id });
}

function read_all() {
  return wsService.make_post_request(section + "/read-all", {});
}

export const notificationService = {
  section,
  filter,
  read,
  read_all,
};
